import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/alert/modal.module.css";

export default {
  "container": "modal-module__container_JpdmVq__010",
  "content": "modal-module__content_JpdmVq__010",
  "footer": "modal-module__footer_JpdmVq__010",
  "header": "modal-module__header_JpdmVq__010",
  "modalHide": "modal-module__modal-hide_JpdmVq__010",
  "modalPop": "modal-module__modal-pop_JpdmVq__010",
  "overlay": "modal-module__overlay_JpdmVq__010"
};
      